// Browser views must not reuse the short-lived signature saved with a stimulus.
// Keep the stored URL intact: AI providers still use its GCS object identity.
const uploadBuckets = new Set(
  [
    'handwritten_new',
    'handwritten-uploads-staging',
    (process.env.REACT_APP_STIMULUS_UPLOAD_BUCKET || '').trim(),
  ].filter(Boolean)
);
const uploadedName =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_[^/\\\u0000-\u001f\u007f]+$/i;

export const stimulusFileUrl = (value) => {
  if (typeof value !== 'string') return value;
  try {
    const url = new URL(value);
    if (
      url.protocol !== 'https:' ||
      url.hostname !== 'storage.googleapis.com' ||
      url.port ||
      url.username ||
      url.password
    )
      return value;
    const [, bucket, ...segments] = url.pathname.split('/');
    if (!uploadBuckets.has(bucket) || segments.length !== 1) return value;
    const blobName = decodeURIComponent(segments[0]);
    if (!uploadedName.test(blobName)) return value;
    const base = (
      process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080'
    ).replace(/\/+$/, '');
    return `${base}/files/stimulus?bucket=${encodeURIComponent(
      bucket
    )}&blobName=${encodeURIComponent(blobName)}`;
  } catch {
    return value;
  }
};
